<div *ngIf="properties" class="note-properties-grid" [ngClass]="{'carry-forward-layout' : carryForwardEnabled, 'cocreators-layout': showCoCreators }">

<!--DESKTOP-->
    <ng-container *ngIf="!viewIsNarrow">
        <div class="p-grid">
            <div class="p-col-10">
                <ng-container *ngTemplateOutlet="noteTimeTemplate"></ng-container>
            </div>
            <div class="p-col-2">
                <ng-container *ngTemplateOutlet="helpButtonTemplate"></ng-container>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-10">
                <ng-container *ngTemplateOutlet="carryForwardTemplate"></ng-container>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-10">
                <ng-container *ngTemplateOutlet="turnoverTemplate"></ng-container>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-5">
                <ng-container *ngTemplateOutlet="attachmentsTemplate"></ng-container>
            </div>
            <div class="p-col-5">
                <ng-container *ngTemplateOutlet="tagsTemplate"></ng-container>
            </div>
        </div>

        <div *ngIf="showCoCreators" class="p-grid">
            <div class="p-col-10">
                <ng-container *ngTemplateOutlet="coCreatorsTemplate"></ng-container>
            </div>
        </div>
    </ng-container>

<!--MOBILE-->
    <ng-container *ngIf="viewIsNarrow">
        <div class="p-grid">
            <div class="p-col-1 p-offset-11 p-d-flex p-jc-end">
                <ng-container *ngTemplateOutlet="helpButtonTemplate"></ng-container>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-6 p-d-flex p-flex-column p-ai-center">
                <ng-container *ngTemplateOutlet="noteTimeTemplate"></ng-container>
            </div>
            <div class="p-col-6">
                <div class="p-grid p-nogutter">
                    <div class="p-col-12">
                        <ng-container *ngTemplateOutlet="carryForwardTemplate"></ng-container>
                    </div>
                    <div class="p-col-12">
                        <ng-container *ngTemplateOutlet="turnoverTemplate"></ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div [ngClass]="!showCoCreators ? 'p-col-6' : 'p-col-4'">
                <ng-container *ngTemplateOutlet="attachmentsTemplate"></ng-container>
            </div>
            <div [ngClass]="!showCoCreators ? 'p-col-6' : 'p-col-4'">
                <ng-container *ngTemplateOutlet="tagsTemplate"></ng-container>
            </div>
            <div *ngIf="showCoCreators" class="p-col-4">
                <ng-container *ngTemplateOutlet="coCreatorsTemplate"></ng-container>
            </div>
        </div>
    </ng-container>
</div>


<ng-template #helpButtonTemplate>
    <span class="fa fa-question-circle clickable" pTooltip="Help" (click)="setDialogMode('help')"></span>
</ng-template>

<ng-template #noteTimeTemplate>
    <label for="prop-note-time">Note Time</label>
    <div *ngIf="!isPublishedNote && displayDate" class="w-100 p-text-center">
        {{displayDate | date: 'mediumDate'}}
    </div>
    <div class="w-100">
        <p-calendar #noteTimeCalendar
                    inputId="prop-note-time"
                    inputStyleClass="p-text-center p-px-0"
                    [placeholder]="isPublishedNote ? 'MM/DD/YYYY HH:MM' : 'HH:MM'"
                    [formControl]="getCalendarControl('time', noteTimeCalendar).control"
                    [timeOnly]="!isPublishedNote"
                    [showTime]="true"
                    [maxDate]="$any( isPublishedNote ? maxDate : null )"
                    [selectOtherMonths]="true"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    [yearRange]="yearRange"
                    [keepInvalid]="true"
                    (onShow)="updateMaxDate()"
                    [showIcon]="true"
                    [showOnFocus]="false"
                    [hideOnDateTimeSelect]="false"
                    [showOtherMonths]="true"
                    [touchUI]="mobileView"
                    appendTo="body">
            <ng-template pTemplate="header">
                <div class="p-grid p-nogutter">
                    <div class="p-col-9 p-d-flex p-ai-center p-pl-2">
                        <label *ngIf="mobileView">Note Time</label>
                    </div>
                    <div class="p-col-3 p-text-right">
                        <button pButton class="p-button-text p-button-rounded p-button-secondary btn-standard" icon="pi pi-times" (click)="noteTimeCalendar.hideOverlay()"></button>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <div *ngIf="!isPublishedNote" class="p-grid">
                    <div class="p-col-12 p-pb-0">
                        <button pButton label="Clear" (click)="getCalendarControl('time', noteTimeCalendar).setValue(null)"></button>
                    </div>
                </div>
            </ng-template>
        </p-calendar>
    </div>
</ng-template>

<ng-template #carryForwardTemplate>
    <ng-container *ngIf="!carryForwardEnabled" [ngTemplateOutlet]="carryForwardToggle"></ng-container>

    <p-panel class="carry-forward-panel" *ngIf="carryForwardEnabled">
        <ng-template pTemplate="header">
            <ng-container *ngTemplateOutlet="carryForwardToggle"></ng-container>
        </ng-template>
        <label for="carry-forward-input">{{getEndTimeString(false)}}</label>
        <div class="p-col p-text-center p-text-md-left">
            <p-calendar *ngIf="carryForwardEnabled"
			            #carryForwardCalendar
                        inputId="carry-forward-input"
                        inputStyleClass="p-text-center p-px-0"
                        [showOnFocus]="false"
                        [formControl]="getCalendarControl('carryForward', carryForwardCalendar).control"
                        [showTime]="true"
                        [selectOtherMonths]="true"
                        [yearNavigator]="true"
                        [keepInvalid]="true"
                        [hideOnDateTimeSelect]="false"
                        placeholder="Indefinitely"
                        [yearRange]="yearRange"
                        [showIcon]="true"
                        [touchUI]="mobileView"
                        appendTo="body">
                <ng-template pTemplate="header">
                    <div class="p-grid p-nogutter">
                        <div class="p-col-9 p-d-flex p-ai-center p-pl-2">
                            <label *ngIf="mobileView">Carry Forward End Time</label>
                        </div>
                        <div class="p-col-3 p-text-right">
                            <button pButton class="p-button-text p-button-rounded p-button-secondary btn-standard" icon="pi pi-times" (click)="carryForwardCalendar.hideOverlay()"></button>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="footer">
                    <div class="p-grid">
                        <div class="p-col-12 p-pb-0">
                            <button pButton label="No End Time" (click)="getCalendarControl('carryForward', carryForwardCalendar).setValue(null); carryForwardCalendar.hideOverlay()"></button>
                        </div>
                    </div>
                </ng-template>
            </p-calendar>
        </div>
    </p-panel>

    <ng-template #carryForwardToggle>
        <div class="toggle-container">
            <label [pTooltip]="carryForwardEnabled ? 'Carry Forward Enabled' : 'Carry Forward Disabled'">
                <span class="fa fa-clock-o fa-lg"></span>
                <p-inputSwitch [(ngModel)]="properties!.carryforward.enabled" (ngModelChange)="triggerNoteSync()"></p-inputSwitch>
            </label>
        </div>
    </ng-template>
</ng-template>

<ng-template #turnoverTemplate>
    <div class="p-grid p-nogutter">
        <div class="p-col-12 toggle-container">
            <label pTooltip="Turnover {{turnOverEnabled ? 'Enabled' : 'Disabled'}}">
                <span class="turnover-icon fa-lg"></span>
                <p-inputSwitch [(ngModel)]="properties!.turnover" (ngModelChange)="triggerNoteSync()"></p-inputSwitch>
            </label>
        </div>
    </div>
</ng-template>

<ng-template #attachmentsTemplate>
    <p-button styleClass="p-button-outlined" icon="pi pi-paperclip"
              (onClick)="setDialogMode('attachments')"
              badgeClass="p-badge-danger"
              pTooltip="{{attachmentCount}} attachments"
              [badge]="attachmentCountDisplay">
    </p-button>
</ng-template>

<ng-template #tagsTemplate>
    <p-button styleClass="p-button-outlined"
              icon="fa fa-tags"
              [badge]="tagCountDisplay" badgeClass="p-badge-danger"
              [pTooltip]="tagString"
              tooltipStyleClass="whitespace-pre-line"
              (onClick)="setDialogMode('tags')">
    </p-button>
</ng-template>

<ng-template #coCreatorsTemplate>
    <p-button styleClass="p-button-outlined"
              icon="pi pi-users"
              [pTooltip]="coCreatorString"
              [badge]="$any(coCreatorCount)"
              badgeClass="p-badge-danger"
              tooltipStyleClass="whitespace-pre-line"
              (click)="setDialogMode('coCreators')">
    </p-button>
</ng-template>


<p-confirmDialog key="invalidNoteTimeDialog"></p-confirmDialog>

<p-dialog styleClass="note-properties-dialog"
          [header]="getHeaderText()"
          [(visible)]="dialogVisible"
          [modal]="true"
          [draggable]="false"
          [focusTrap]="true"
          [dismissableMask]="true"
          position="top"
          [style]="{width: '750px'}"
          [resizable]="false"
          appendTo="body">
    <ng-container [ngSwitch]="dialogMode">
        <ng-container *ngSwitchCase="'coCreators'">
            <p-table [value]="coCreators">
                <ng-template pTemplate="body" let-logUser>
                    <tr>
                        <td>
                            <p-inputSwitch [ngModel]="logUser.selected" [disabled]="logUser.selected && coCreatorCount <= 1"
                                           [pTooltip]="logUser.selected && coCreatorCount <= 1 ? 'A note must have at least one co-creator' : ''"
                                           (ngModelChange)="triggerNoteSync(); changeUserSelected(logUser)">
                            </p-inputSwitch>
                        </td>
                        <td>{{logUser.user.firstName}}</td>
                        <td>{{logUser.user.lastName}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </ng-container>
        <ng-container *ngSwitchCase="'attachments'">
            <lb-file-uploader [(ngModel)]="properties!.attachments" (ngModelChange)="triggerNoteSync()"></lb-file-uploader>
        </ng-container>
        <ng-container *ngSwitchCase="'tags'">
            <tag-selector [logId]="selectedLogId" [(ngModel)]="tagValues" (ngModelChange)="triggerNoteSync()"></tag-selector>
        </ng-container>
        <ng-container *ngSwitchCase="'help'">
            <p-table tableStyleClass="help-table" [value]="helpRows" [autoLayout]="true">
                <ng-template pTemplate="body" let-type>
                    <tr>
                        <ng-container [ngSwitch]="type">
                            <ng-container *ngSwitchCase="'noteTime'">
                                <td>
                                    <span>Note Time</span>
                                </td>
                                <td>
                                    <span *ngIf="isPublishedNote">
                                        Use the control to set the time and date of the note.<br>
                                        The note cannot be set to be in the future.
                                    </span>
                                    <span *ngIf="!isPublishedNote">
                                        Use the control to set the time of the note. Leave blank to set the note to be set to the current time.<br>
                                        If the time is set within 12 hours the note date will update to match.<br>
                                        The note cannot be set to be in the future.
                                    </span>
                                    <br>
                                    <a (click)="$event.preventDefault(); openHelp()">
                                        See help for note time for a more complete understanding of this Note feature.
                                    </a>
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'attachments'">
                                <td>
                                    <i class="pi pi-paperclip fa-lg"></i>
                                    <span>Attachments</span>
                                </td>
                                <td>
                                    Add, see or remove file attachments for the Note.
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'tags'">
                                <td>
                                    <i class="fa fa-tags fa-lg"></i>
                                    <span>Tags</span>
                                </td>
                                <td>
                                    Add, see or remove tags for the Note.
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'coCreators'">
								<ng-container *ngIf="!isOperational && !isPublishedNote">
									<td>
										<i class="pi pi-users fa-lg"></i>
										<span>Co-Creators</span>
									</td>
									<td>
										Add co-creators to this note. This allows other users to work on this draft.
									</td>
								</ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'turnover'">
                                <td>
                                    <i class="turnover-icon fa-lg"></i>
                                    <span>Turnover</span>
                                </td>
                                <td>
                                    Control whether the Note should be designated as a Turnover Note or not.
                                    Turnover Notes are often used to flag significant Notes that are essential for the next Shift to Acknowledge prior
                                    to the start of their watch.
                                    <br>
                                    <a (click)="$event.preventDefault(); openHelp()">
                                        See help for Turnover Notes for a more complete understanding of this Note feature.
                                    </a>
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'carryForward'">
                                <td>
                                    <i class="fa fa-clock-o fa-lg"></i>
                                    <span>Carry Forward</span>
                                </td>
                                <td>
                                    Control whether the Note should be "carried forward" until some future time.
                                    <br>
                                    <a (click)="$event.preventDefault(); openHelp()">
                                        See help for Carry Forward Notes for a more complete understanding of this Note feature.
                                    </a>
                                </td>
                            </ng-container>
                        </ng-container>
                    </tr>
                </ng-template>
            </p-table>
        </ng-container>
    </ng-container>
</p-dialog>
